<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="mt-0 mb-2">
        {{ $t('developer-tab.webrtc-credentials.title') }}
      </h1>
      <router-link :to="{ name: 'create-webrtc-credentials' }">
        <button class="mx-2 px-3 btn btn-primary btn-sm">
          {{ $t('developer-tab.webrtc-credentials.generate') }}
        </button>
      </router-link>
    </div>
    <data-table
      ref="webrtcCredentials"
      :data="credentials"
      :fields="translatedFields"
      :isLoading="credentialsIsLoading"
      :pagination="pagination"
    >
      <template slot="actions" slot-scope="props">
        <button
          class="mx-2 px-3 btn btn-secondary btn-sm"
          @click="restoreCredential(props.rowData.id)"
          v-if="props.rowData.isDeleted"
        >
          {{ $t('developer-tab.webrtc-credentials.table.restore') }}
        </button>
        <button
          class="mx-2 px-3 btn btn-primary btn-sm"
          @click="onEditCredential(props.rowData)"
          v-if="!props.rowData.isDeleted"
        >
          {{ $t('developer-tab.webrtc-credentials.table.edit') }}
        </button>
        <button
          class="mx-2 px-3 btn btn-danger btn-sm"
          @click="deleteCredential(props.rowData.id)"
          v-if="!props.rowData.isDeleted"
        >
          {{ $t('developer-tab.webrtc-credentials.table.delete') }}
        </button>
      </template>
    </data-table>

    <modal
      :isOpen="isModalOpen"
      @dismiss="isModalOpen = false"
      :title="$t('developer-tab.webrtc-credentials.edit-form.title')"
    >
      <EditCredentialForm
        :currentCredential="editedCredential"
        @submit="
          fetchCredentials()
          isModalOpen = false
        "
      />
    </modal>
  </div>
</template>

<script>
import Vue from 'vue'
import WebRTCCredentialsService from '../../../../services/webrtcCredentials.service'
import DataTable from '../../../../elements/DataTable.vue'
import Modal from '../../../../elements/Modal'

import apiKey from './cells/apiKey.vue'
import domains from './cells/domains.vue'
import isDeleted from './cells/isDeleted.vue'
import EditCredentialForm from './components/EditCredentialForm.vue'

Vue.component('apiKey', apiKey)
Vue.component('domains', domains)
Vue.component('isDeleted', isDeleted)

export default {
  components: { DataTable, Modal, EditCredentialForm },
  data() {
    return {
      credentials: [],
      fields: [
        {
          name: '__component:apiKey',
          title: 'developer-tab.webrtc-credentials.table.api-key'
        },
        {
          name: '__component:domains',
          title: 'developer-tab.webrtc-credentials.table.domains',
          width: '40%'
        },
        {
          name: '__component:isDeleted',
          title: 'developer-tab.webrtc-credentials.table.is-deleted'
        },
        {
          name: '__slot:actions',
          title: 'developer-tab.webrtc-credentials.table.actions'
        }
      ],
      pagination: {
        perPage: 10
      },
      credentialsIsLoading: false,
      isModalOpen: false,
      editedCredential: {
        domains: []
      }
    }
  },
  computed: {
    translatedFields() {
      return this.fields.map(field => ({
        ...field,
        title: this.$t(field.title)
      }))
    }
  },
  methods: {
    async fetchCredentials() {
      const credentials = await WebRTCCredentialsService.fetchAllCredentials()
      this.credentials = credentials
    },
    onEditCredential(credential) {
      this.editedCredential = { ...credential }
      this.isModalOpen = true
    },
    async deleteCredential(id) {
      try {
        await WebRTCCredentialsService.deleteCredential(id)
        this.toast(this.$t('developer-tab.webrtc-credentials.toasts.delete'))
        this.fetchCredentials()
      } catch (error) {
        this.toast(error.response.data.message, { type: 'error' })
      }
    },
    async restoreCredential(id) {
      try {
        await WebRTCCredentialsService.restoreCredential(id)
        this.toast(this.$t('developer-tab.webrtc-credentials.toasts.restore'))
        this.fetchCredentials()
      } catch (error) {
        this.toast(error.response.data.message, { type: 'error' })
      }
    }
  },
  mounted() {
    this.fetchCredentials()
  }
}
</script>

<style scoped lang="scss">
.gap-2 {
  gap: 0.5rem;
}
</style>
